module.exports = __webpack_public_path__ + "img/inter16.ec67c4e1.jpg";